import { createTheme } from '@mui/material';
import { ZIndex } from '@mui/material/styles/zIndex';
import { muiThemeBreakpoints } from './breakpoints';
import overrides from './overrides';

import palette from './palette';
import shadows from './shadows';
import typography from './typography';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

declare module '@mui/material/styles' {
  interface TypeBackground {
    dark: string;
    default: string;
    paper: string;
  }
}

export const muiTheme = createTheme({
  palette,
  typography,
  components: overrides,
  shadows,
  breakpoints: {
    values: muiThemeBreakpoints,
  },
  spacing: (factor: number) => factor * 8,
  zIndex: <ZIndex>{
    appBar: 1200,
    drawer: 1100,
  },
});
